import React, { useContext } from 'react';
import { getContext } from 'common';
import { AppToolbarContext } from './';
import Styled from './styles';

export interface AppToolbarTitleContainerProps extends React.ComponentPropsWithRef<'div'> {
  /** The title and subtitle. Consider using AppToolbarTitle and AppToolbarSubtitle. */
  children?: React.ReactNode;
}

/** AppToolbarTitleContainer component. Container for the AppToolbar title and subtitle. Any other props will be
 * passed to the root element.
*/
const AppToolbarTitleContainer = React.forwardRef<HTMLElement, AppToolbarTitleContainerProps>((props: AppToolbarTitleContainerProps, ref) =>
  getContext(({ RTL }: { RTL: boolean }) => {
    const {
      children,
      ...otherProps
    } = props;
    const appToolbarContext: any = useContext(AppToolbarContext);
    return (
      <Styled.Titles $rtl={RTL} ref={ref} $deviceType={appToolbarContext.deviceType} {...otherProps}>
        {children}
      </Styled.Titles>
    );
  }));

AppToolbarTitleContainer.defaultProps = {
  children: undefined,
};

AppToolbarTitleContainer.displayName = 'AppToolbarTitleContainer';
export default AppToolbarTitleContainer;
